/**
 * Overlay-related semantic tokens for PrimeNG preset
 * Modal uses modalTokens from component layer for Figma parity
 */

import { modalTokens, createModalTokens } from '../tokens/components.js';
import * as p from '../tokens/primitives.js';
import { border, layout, surface, text, type SemanticTokens } from '../tokens/semantic.js';

export const overlays = {
  // Overlay tokens
  overlay: {
    select: {
      borderRadius: p.borderRadius[8],
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
      background: surface.ground,
      border: {
        color: border.divider,
        radius: p.borderRadius[8],
      },
      color: text.secondary,
    },
    popover: {
      borderRadius: p.borderRadius[8],
      padding: layout.padding.sm,
      shadow: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
      border: {
        radius: p.borderRadius[8],
      },
    },
    modal: {
      borderRadius: modalTokens.base.radius,
      padding: modalTokens.base.paddingX,
      shadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
      border: {
        radius: modalTokens.base.radius,
      },
    },
  },
};

export function createOverlays(s: SemanticTokens, mt: ReturnType<typeof createModalTokens>) {
  return {
    overlay: {
      select: {
        borderRadius: p.borderRadius[8],
        shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
        background: s.surface.ground,
        border: {
          color: s.border.divider,
          radius: p.borderRadius[8],
        },
        color: s.text.secondary,
      },
      popover: {
        borderRadius: p.borderRadius[8],
        padding: s.layout.padding.sm,
        shadow: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
        border: {
          radius: p.borderRadius[8],
        },
      },
      modal: {
        borderRadius: mt.base.radius,
        padding: mt.base.paddingX,
        shadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
        border: {
          radius: mt.base.radius,
        },
      },
    },
  };
}
